import { useFormikContext } from "formik";
import * as Yup from "yup";
import { AttachmentSnapshot } from "../../../../clients/graphqlTypes.js";
import { FilesBox } from "../../../commons/files/FilesBox.js";
import { getAttachmentValidationSchema } from "../../attachments/AttachmentField.js";
import React from "react";

interface NewFile {
  id: string;
  file: File;
}

export type FormValues = {
  attachments: Array<AttachmentSnapshot | NewFile>;
};
export function useValidationSchema() {
  return Yup.object().shape({
    attachments: Yup.array(getAttachmentValidationSchema()),
  });
}

export function ProductOverviewFilesBoxForm() {
  const { values, setValues } = useFormikContext<FormValues>();

  const attachments = React.useMemo(() => {
    return values.attachments.map(attachment => {
      if ("file" in attachment) {
        return {
          id: attachment.id,
          url: URL.createObjectURL(attachment.file),
          title: attachment.file.name,
          mimeType: attachment.file.type,
        };
      }
      return attachment;
    });
  }, [values.attachments]);

  return (
    <FilesBox
      isInitiallyClosed={false}
      attachments={attachments}
      handleAdd={async files => {
        setValues(values => ({
          ...values,
          attachments: values.attachments.concat(
            files.map(file => ({
              id: `new-${file.name}`,
              file,
            }))
          ),
        }));
      }}
      handleDelete={attachmentId => {
        setValues(values => ({
          ...values,
          attachments: values.attachments.filter(a => a.id !== attachmentId),
        }));
      }}
    />
  );
}
